module.exports = __webpack_public_path__ + "assets/img/sidemenu-item03.a86b9a55.svg";